"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreRpcLocal = void 0;
const utils_1 = require("@streamr/utils");
const timestamp_1 = require("../../../generated/google/protobuf/timestamp");
const identifiers_1 = require("../../identifiers");
const logger = new utils_1.Logger(module);
class StoreRpcLocal {
    options;
    constructor(options) {
        this.options = options;
    }
    async storeData(request) {
        logger.trace('storeData()');
        const key = (0, identifiers_1.toDhtAddress)(request.key);
        const isLocalNodeStorer = this.isLocalNodeStorer(key);
        this.options.localDataStore.storeEntry({
            key: request.key,
            data: request.data,
            creator: request.creator,
            createdAt: request.createdAt,
            storedAt: timestamp_1.Timestamp.now(),
            ttl: request.ttl,
            stale: !isLocalNodeStorer,
            deleted: false
        });
        if (!isLocalNodeStorer) {
            this.options.localDataStore.setAllEntriesAsStale(key);
        }
        return {};
    }
    async replicateData(request, context) {
        logger.trace('server-side replicateData()');
        const dataEntry = request.entry;
        const wasStored = this.options.localDataStore.storeEntry(dataEntry);
        if (wasStored) {
            this.replicateDataToNeighbors(context.incomingSourceDescriptor, request.entry);
        }
        const key = (0, identifiers_1.toDhtAddress)(dataEntry.key);
        if (!this.isLocalNodeStorer(key)) {
            this.options.localDataStore.setAllEntriesAsStale(key);
        }
        logger.trace('server-side replicateData() at end');
        return {};
    }
    isLocalNodeStorer(dataKey) {
        return this.options.getStorers(dataKey).some((p) => (0, identifiers_1.areEqualPeerDescriptors)(p, this.options.localPeerDescriptor));
    }
    replicateDataToNeighbors(requestor, dataEntry) {
        const dataKey = (0, identifiers_1.toDhtAddress)(dataEntry.key);
        const storers = this.options.getStorers(dataKey);
        const isLocalNodePrimaryStorer = (0, identifiers_1.areEqualPeerDescriptors)(storers[0], this.options.localPeerDescriptor);
        // If we are the closest to the data, get storageRedundancyFactor - 1 nearest node to the data, and
        // replicate to all those node. Otherwise replicate only to the one closest one. And never replicate 
        // to the requestor nor to itself.
        const targets = (isLocalNodePrimaryStorer ? storers : [storers[0]]).filter((p) => !(0, identifiers_1.areEqualPeerDescriptors)(p, requestor) && !(0, identifiers_1.areEqualPeerDescriptors)(p, this.options.localPeerDescriptor));
        targets.forEach((target) => {
            setImmediate(() => {
                (0, utils_1.executeSafePromise)(() => this.options.replicateDataToContact(dataEntry, target));
            });
        });
    }
}
exports.StoreRpcLocal = StoreRpcLocal;
//# sourceMappingURL=StoreRpcLocal.js.map